export default __webpack_public_path__ + "static/walimatul-ursy-2f421684481332214e24c4799c5ccd9a.png";